<template>
  <div>
    <h2 class="text-primary-dark seccion">Teléfonos de asistencia</h2>
    <loading v-if="loading"/>
    <div v-else v-for="cia in companias" :key="cia.id">
      <div>
        <h5 class="text-primary-dark border-bottom text-uppercase">
          <logo-cia :id="cia.id" width="200" height="101"/>
          Telefonos de asistencia de {{ cia.compania }}
        </h5>
        <table class="table">
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Teléfono</th>
            </tr>
          </thead>
          <tr v-for="tel in cia.telefonos" :key="tel.telefono">
            <td class="text-uppercase">{{ tel.descripcion }}</td>
            <td style="width: 50px;" class="text-nowrap text-right"><a :href="'tel:'+tel.telefono">{{ tel.telefono }}</a></td>
          </tr>
        </table>
      </div>
    </div> 
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LogoCia from '@/components/widgets/LogoCia'
import Loading from '@/components/widgets/Loading'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      telefonosAsistencia: 'telefonosAsistencia'
    }),
    companias(){
      let tmpCias = this.telefonosAsistencia;
      let cias = [];
      let tmp = {};

      // Formateo simple
      tmpCias.forEach(function(telefono){
        tmp = {'compania': telefono.compania.nombre, 'id':telefono.compania.id, 'telefonos': []};
        cias.push(tmp);
      });

      // Agrupar por compañía
      tmpCias.forEach(function(telefono){
        //Sacar indice de la compania de este telefono
        let indice = null;
        cias.forEach(function(cia,index){
            if(cia.id == telefono.compania.id){
                indice = index;
            }
        });

        cias[indice].telefonos.push({'telefono': telefono.telefono, 'descripcion': telefono.descripcion});
      });

      // Filtrar repetidos
      cias = _.filter(cias, function(cia) {
        return cia.telefonos.length > 0;
      });

      // Ordenar por orden alfabético
      cias.sort(function(a, b){
        if(a.compania < b.compania) return -1;
        if(a.compania > b.compania) return 1;
        return 0;
      });

      return cias;
    }
  },
  mounted() {
    this.loadTelefonosAsistencia()
  },
  methods: {
    loadTelefonosAsistencia() {
      console.log("H")
      if (this.telefonosAsistencia == 0) { 
        this.loading = true;
      }
      let payload = {
        params: {
          'page': 1,
          'limit': 50
        },
        callbackOk: (responses) => {
          this.loading = false
        },
        callbackError: (error) => {
          this.loading = false;
          if (error.status === 401) {
            this.$router.push({name:'Login'});
          }
        }
      }
      this.$store.dispatch("loadTelefonosAsistencia", payload);
    }
  },
  components: {
    LogoCia,
    Loading
  }
}
</script>

<style>

</style>
